import { FC } from "react";
import './header.css';
import logo from "../img/logo.png"
import { PhoneOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Link } from 'react-router-dom';

export const Header: FC = () => {
    return (
        <header className="header">
            <div className="header__container">
                <Link to="/" className="header__logo-link">
                    <img src={logo} className="header__logo" alt="Цветочный магазин «Ваниль» — Булгаково и Уфа" />
                </Link>
                <nav className="header__info">
                    <Link to="/bukety-na-zakaz" className="header__nav-link">Букеты на заказ</Link>
                    <Link to="/dostavka-ufa" className="header__nav-link">Доставка</Link>
                    <Link to="/about" className="header__nav-link">О нас</Link>
                    <Link to="/blog" className="header__nav-link">Блог</Link>
                </nav>
                <Button type="primary" icon={<PhoneOutlined />} className="header__button" style={{ background: '#d48806', borderColor: '#d48806' }}>
                    <a href="tel:+79872588111" style={{ color: '#fff', textDecoration: 'none' }}>+7 (987) 258-81-11</a>
                </Button>
            </div>
        </header>
    );
};